module.exports = __webpack_public_path__ + "static/img/11.01759424.png";